import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserListState } from "./admin-userlist.reducer";

const selectAdminUserFeature = createFeatureSelector<UserListState>("adminUsers");

export const selectAdminUsers = createSelector(selectAdminUserFeature, state => {
    return state.userlist;
});